import React from 'react';
import { AiRovoCurrentRouteConfigurationProviderWithBoundary } from './AiRovoCurrentRouteConfigurationProviderWithBoundary.tsx';

export const AiRovoRouteProvider = (): React.JSX.Element => {
	return (
		<>
			<AiRovoCurrentRouteConfigurationProviderWithBoundary />
		</>
	);
};
